import React from "react";

const RefundPolicyComponent = () => {
  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="container">
        <div className="main-body">
          <div className="row gutters-sm justify-content-center">
            <div className="col-md-12">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "30px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                }}
              >
                Our Refund Policy
              </h1>
              <h4
                style={{
                  textAlign: "center",
                  fontWeight: "600",
                  paddingBottom: "40px",
                  marginBottom: "40px",
                  borderBottom: " 1px solid #1ea3fe",
                }}
              >
                At Connection Hub Portal we want our users to be completely
                satisfied with their purchase of our marketplace products and /
                or services.
              </h4>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                We therefore recommend to read our Refund and Return Policy
                prior to you making a purchase from Connection Hub Portal, so
                you are familiar with our policy on refunds and your rights
                under the law of Dubai, United Arab Emirates.
                <br />
                <br />
                We also recommend you immediately inspect any goods you receive
                as well as count all items received or the items contained in
                your delivery to ensure you are completely satisfied with the
                goods, including the goods are of acceptable quality, and match
                the description the vendor has agreed to deliver.
                <br />
                <br />
                We are a marketplace that connects users with laundry companies,
                the exact details of the refund will depend on the individual
                laundry companies’ policy. However, where the individual laundry
                vendor does not have a proper damage or lost clause we will
                refund up to 10 times the cost of the service.
                <br />
                <br />
                If you have any questions about this policy, please contact us
                at info@thelaundrypotal.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicyComponent;
